export default "__VITE_ASSET__BjY_PRjR__"